import { lerpColor } from '../../color';
import { hsl, type World } from '../../world';
import { dress, fx } from './dress';
import { paint } from './paint';
import './world.css';

const H = 150;
const S = 38;
const A1 = 340;
const A2 = 48;

const L = hsl(H, 72, 82);
const HELD = hsl(A1, 88, 78);
const SPOT = hsl(A2, 85, 76);
const RIM = hsl(H, 45, 92);

const world: World = {
  id: 'igarape',
  name: 'Igarapé',
  seed: 'igarape',
  legacy: false,
  hue: H,
  ceil: hsl(H, 0.8 * S, 28),
  font: 'Gluten',
  fontFile: 'gluten-800.woff2',
  fontWeight: '800',
  fontLicense: 'OFL-1.1',
  dark: true,
  boil: true,
  glow: 'add',
  glowAlpha: 0.24,
  fillAlpha: 0.8,
  palette: {
    bg: hsl(H, S, 10),
    ink: hsl(H, S + 12, 5),
    rim: RIM,
    held: HELD,
    heldShade: hsl(A1, 60, 60),
    heldLight: hsl(A1, 90, 90),
    incoming: {
      circle: L,
      square: SPOT,
      triangle: lerpColor(L, HELD, 0.5),
      hex: lerpColor(L, SPOT, 0.5),
    },
    spot: SPOT,
    path: hsl(H, 30, 72),
    text: hsl(H, 40, 94),
    sparks: [HELD, SPOT, L, RIM],
  },
  burst: { count: 12, speed: 0.5, drag: 3.5, gravity: 0, spin: 3, life: 0.9, sizeMin: 0.009, sizeMax: 0.021 },
  dress,
  fx,
  paint,
};

export default world;
